import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SubdirectoryArrowRightIcon from "@mui/icons-material/SubdirectoryArrowRight";
import { useState } from "react";
import { useRecoilState } from "recoil";
import { ShowProgress } from "../../state/ShowProgress";
import { toast } from "react-toastify";
import { generateRandomRequestID, validateFields } from "../../common/helper";
import * as yup from "yup";
import { ExtensionHandler, JsonRpc } from "upcx-js";

type Props = {
  item: any;
  contractName: string;
  connectedAddress: string | undefined;
};

export const WriteContractItem = ({
  item,
  contractName,
  connectedAddress,
}: Props) => {
  const theme = useTheme();

  const [, setShowProgress] = useRecoilState(ShowProgress);

  const [fields, setFields] = useState<string[]>(
    new Array(item.fields.length).fill("")
  );

  const [result, setResult] = useState<string>("");

  const validate = async () => {
    try {
      // await validateFields(
      //   yup.object().shape({
      //     fields: yup.array().of(yup.string().required("Please input value.")),
      //   }),
      //   ["fields"],
      //   [fields]
      // );
      return true;
    } catch (err: any) {
      toast.warn(err.message);
      return false;
    }
  };

  const handleWriteContract = async () => {
    if (!(await validate())) {
      return;
    }

    const lastRequestID = generateRandomRequestID();

    ExtensionHandler.instance().setRequestProcessedHandler(
      (requestID: string, accept: boolean) => {
        if (requestID !== lastRequestID) {
          return;
        }

        if (accept) {
          setResult("Success");
          toast.success("Writing Smart Contract has been successful.");
        } else {
          setResult("Rejected");
        }

        setShowProgress(false);
      }
    );

    setShowProgress(true);

    ExtensionHandler.instance()
      .signConirmTx(
        lastRequestID,
        parseInt(process.env.REACT_APP_CHAIN_ID!),
        connectedAddress!,
        contractName,
        item.name,
        fields
      )
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleField = (value: string, index: number) => {
    let tmpFields = [...fields];
    tmpFields[index] = value;
    setFields(tmpFields);
  };

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
        sx={{
          "*.Mui-expanded": {
            margin: "10px 0px !important",
          },
          "&.Mui-expanded": {
            minHeight: "30px",
          },
        }}
      >
        {item.name}
      </AccordionSummary>
      <AccordionDetails
        sx={{
          borderTop: `1px solid ${theme.palette.divider}`,
        }}
      >
        <div className="p-0">
          <div className="form-group">
            {item.fields.map((field: any, index: number) => {
              return (
                <div className="form-group" key={index}>
                  <label className="mb-2">
                    {field.name}({field.type})
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-xs mb-2"
                    name="input_3"
                    id="input_3_1"
                    data-bs-grp="g3"
                    data-bs-type="uint256"
                    placeholder={`${field.name}(${field.type})`}
                    value={fields[index]}
                    onChange={(e) => handleField(e.target.value, index)}
                  />
                </div>
              );
            })}
            <button
              type="button"
              id="btn_3"
              className="btn btn-light border"
              onClick={handleWriteContract}
              disabled={connectedAddress ? false : true}
            >
              Write
            </button>
          </div>
          <div className="text-secondary mt-3">
            <SubdirectoryArrowRightIcon
              className="far fa-code text-secondary me-1"
              sx={{
                width: "18px",
                height: "18px",
                margin: "-5px 5px auto 0px",
              }}
            />
            <span className="text-monospace text-muted">Result</span>
            <br />
            <span id="myanswer_3">{result}</span>
          </div>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};
